(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form-grouped"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('monument-region-selector')) {
    class MonumentRegionSelector extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.trigger = this.querySelector('.mg-region__trigger');
        this.panel = this.querySelector('.mg-region__panel');
        this.form = this.closest('form');
        this.choices = Array.from(this.querySelectorAll('.mg-region__language'));
        this.error = this.querySelector('.mg-region__error');
        if (!this.trigger || !this.panel || !this.form || !this.choices.length) return;
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.trigger.addEventListener('click', () => this.setOpen(this.panel.hidden, true), options);
        this.querySelector('.mg-region__close')?.addEventListener('click', () => this.setOpen(false, true), options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.panel.hidden) {
            event.preventDefault(); event.stopPropagation(); this.setOpen(false, true);
          } else if (event.key === 'ArrowDown' && event.target === this.trigger) {
            event.preventDefault(); this.setOpen(true, true);
          }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.panel.hidden && !this.contains(event.target)) this.setOpen(false);
        }, options);
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.setOpen(false);
        }, options);
        this.choices.forEach(choice => choice.addEventListener('click', () => this.select(choice), options));
        window.addEventListener('pagehide', () => this.setOpen(false), options);
        window.addEventListener('pageshow', () => {
          this.resetSubmission();
          this.setOpen(false);
        }, options);
        this.closest('dialog')?.addEventListener('close', () => this.setOpen(false), options);
        this.resetSubmission();
        this.setOpen(false);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resetSubmission();
        this.setOpen(false);
      }

      resetSubmission() {
        this.submitting = false;
        this.form?.removeAttribute('aria-busy');
        this.choices?.forEach(button => { button.disabled = false; });
        if (this.error) this.error.hidden = true;
      }

      setOpen(open, moveFocus = false) {
        if (!this.panel || !this.trigger) return;
        this.panel.hidden = !open;
        this.panel.setAttribute('aria-hidden', String(!open));
        this.trigger.setAttribute('aria-expanded', String(open));
        if (open) {
          if (this.error) this.error.hidden = true;
          if (moveFocus) (this.panel.querySelector('[aria-pressed="true"]') || this.choices[0])?.focus({preventScroll:true});
          if (this.classList.contains('mg-region--mobile')) this.panel.scrollIntoView({block:'nearest',behavior:'instant'});
        } else if (moveFocus) this.trigger.focus({preventScroll:true});
      }

      select(choice) {
        if (this.submitting) return;
        const country = choice.dataset.countryCode;
        const locale = choice.dataset.localeCode;
        const destination = choice.dataset.redirectUrl;
        if (!['US','CA'].includes(country) || !['en','fr'].includes(locale) || (country === 'US' && locale !== 'en') || !destination || !destination.startsWith('/') || destination.startsWith('//')) return;
        const countryInput = this.form.querySelector('input[name="country_code"]');
        const localeInput = this.form.querySelector('input[name="locale_code"]');
        const returnInputs = this.form.querySelectorAll('input[name="return_to"]');
        if (!countryInput || !localeInput || returnInputs.length !== 1) return;
        countryInput.value = country;
        localeInput.value = locale;
        returnInputs[0].value = destination;
        this.submitting = true;
        this.form.setAttribute('aria-busy','true');
        this.choices.forEach(button => { button.disabled = true; });
        try {
          HTMLFormElement.prototype.submit.call(this.form);
        } catch {
          this.resetSubmission();
          if (this.error) this.error.hidden = false;
        }
      }
    }
    customElements.define('monument-region-selector', MonumentRegionSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-compatible-models"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-compatible-models')) {
    customElements.define('product-compatible-models', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        if (this.initialized) return;
        const button = this.querySelector('.compatible-models__toggle');
        if (!button) return;
        this.initialized = true;
        button.hidden = false;
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          this.querySelectorAll('[data-compatible-overflow]').forEach((item) => { item.hidden = !expanded; });
          button.querySelector('[data-compatible-expand]').hidden = expanded;
          button.querySelector('[data-compatible-collapse]').hidden = !expanded;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-compatible-models"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-compatible-models')) {
    customElements.define('variant-compatible-models', class extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.js-product');
        this.onVariantChange = (event) => {
          if (event.target.closest('.js-product') !== this.productSection) return;
          this.refresh(event.detail.variant?.id);
        };
        this.productSection?.addEventListener('on:variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        this.productSection?.removeEventListener('on:variant:change', this.onVariantChange);
        this.request?.abort();
      }

      async refresh(variantId) {
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        // Never show a previous variant's compatibility while loading or on failure.
        this.hidden = true;
        if (!variantId) return;
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.search = window.location.search;
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('variant', variantId);
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Compatible models section request failed');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const updated = document.getElementById(this.id);
          if (!updated || request.signal.aborted || !this.isConnected) return;
          // DOMParser parses noscript with scripting disabled. Moving its style
          // nodes into the live page would force all collapsed groups to display.
          updated.querySelectorAll('noscript').forEach((fallback) => fallback.remove());
          this.replaceChildren(...Array.from(updated.childNodes));
          this.hidden = false;
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Unable to refresh compatible models.', error);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
